import { useState as O, useCallback as q, useMemo as y, useEffect as b } from "react";
import z, { SelectAllOption as B } from "./useSelectAll.js";
import { flattenOptions as D, isOptionsGroup as H } from "./utils.js";
function U({
  value: r = [],
  options: s = [],
  onChange: t,
  withSelectAll: e,
  isDisabled: l,
  fixedValues: i,
  multiSelectRef: a,
  disableAllSelected: W,
  onMenuClose: h,
  onMenuOpen: m
}) {
  const [c, g] = O(!1), [p, E] = O(""), k = (n) => {
    E(n.currentTarget.value);
  }, v = q(() => {
    c && (g(!1), h && h());
  }, [h, c]), A = () => {
    c || (g(!0), m && m());
  }, I = () => {
    l || (c ? v() : A());
  }, M = (n) => {
    const o = r.filter((d) => d.value !== n);
    t(o, { removedValue: n });
  }, L = y(
    () => D(s).filter((n) => i.includes(n.value)),
    [s, i]
  ), w = () => {
    t(L);
  }, {
    optionsWithSelectAll: F,
    valuesWithSelectAll: P,
    isOptionSelected: T,
    onChangeWithSelectAll: j
  } = z(s, r, t, i), u = {
    value: e ? P : r,
    options: e ? F : s,
    onChange: e ? j : t,
    isOptionSelected: e ? T : void 0
  };
  if (i.length && (u.options = C(
    u.options,
    (n) => !i.find((o) => o === n.value)
  ), u.value = J(u.value, L)), p.length) {
    const n = C(
      u.options,
      (o) => o.label !== B.label && o.label.toLowerCase().includes(p.toLowerCase())
    );
    u.options = n;
  }
  return b(() => {
    c || E("");
  }, [c]), b(() => {
    function n(d) {
      var f;
      (f = a == null ? void 0 : a.current) != null && f.contains(d.target) || v();
    }
    function o(d) {
      var f;
      (f = a == null ? void 0 : a.current) != null && f.contains(d.relatedTarget) || v();
    }
    return document.addEventListener("mousedown", n), document.addEventListener("focusout", o), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("focusout", o);
    };
  }, [a, v, c]), {
    removeItem: M,
    removeAll: w,
    onClickMenu: I,
    menuIsOpen: c,
    onChangeSearch: k,
    searchValue: p,
    allSelected: r.length === s.length,
    disableAllSelected: W,
    ...u
  };
}
function C(r, s) {
  return r.reduce(
    (t, e) => {
      if (H(e)) {
        const l = e.options.filter(s);
        return [
          ...t,
          {
            ...e,
            options: l
          }
        ];
      } else
        return s(e) ? [...t, e] : t;
    },
    []
  );
}
function J(r, s) {
  const t = [...r];
  return s.forEach((e) => {
    t.map((l) => l.value).includes(e.value) || t.push(e);
  }), t;
}
export {
  U as default
};
